(function () {
  'use strict';

  function money(cents, cur) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v + ' ' + (cur || '€');
  }

  function initScroller(root) {
    if (!root || root.dataset.lfReady) return;
    root.dataset.lfReady = '1';
    var track = root.querySelector('[data-lf-track]');
    if (!track) return;
    var dots = root.querySelectorAll('[data-lf-dot]');
    var prev = root.querySelector('[data-lf-prev]');
    var next = root.querySelector('[data-lf-next]');
    function slideW() {
      var s = track.children[0];
      if (!s) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return s.getBoundingClientRect().width + gap;
    }
    function index() { return Math.round(track.scrollLeft / slideW()); }
    function go(i) { track.scrollTo({ left: i * slideW(), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(Math.max(0, index() - 1)); });
    if (next) next.addEventListener('click', function () {
      var max = track.children.length - 1;
      var i = index() + 1;
      go(i > max ? 0 : i);
    });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = index();
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, 60);
    }, { passive: true });
    root.goTo = go;
  }

  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  function addBusinessDays(d, n) {
    var r = new Date(d);
    var added = 0;
    while (added < n) {
      r.setDate(r.getDate() + 1);
      var w = r.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return r;
  }
  function fmt(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function initTimeline(root) {
    if (!root || root.dataset.lfReady) return;
    root.dataset.lfReady = '1';
    var now = new Date();
    root.querySelectorAll('[data-lf-date]').forEach(function (el) {
      var a = parseInt(el.dataset.from || '0', 10);
      var b = parseInt(el.dataset.to || '0', 10);
      if (!a && !b) { el.textContent = fmt(now); return; }
      var d1 = addBusinessDays(now, a), d2 = addBusinessDays(now, b);
      el.textContent = fmt(d1) + ' - ' + fmt(d2);
    });
  }

  function initProduct(root) {
    if (!root || root.dataset.lfReady) return;
    root.dataset.lfReady = '1';
    var json = root.querySelector('[data-lf-variants]');
    if (!json) return;
    var variants = [];
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var cur = root.dataset.cur || '€';
    var nowEl = root.querySelector('[data-lf-now]');
    var wasEl = root.querySelector('[data-lf-was]');
    var saveEl = root.querySelector('[data-lf-save]');
    var optName = root.querySelector('[data-lf-optval]');
    var tiers = root.querySelectorAll('[data-lf-tier]');
    var gallery = root.querySelector('[data-lf-gallery]');
    var errEl = root.querySelector('[data-lf-error]');
    var sticky = document.querySelector('[data-lf-sticky="' + root.dataset.section + '"]');

    function currentOptions() {
      var opts = [];
      root.querySelectorAll('[data-lf-opt]').forEach(function (group) {
        var c = group.querySelector('input:checked');
        opts.push(c ? c.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) { if (opts[k] !== null && v.options[k] !== opts[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return variants[0];
    }
    function selected() { return findVariant(currentOptions()); }

    function renderTiers() {
      var v = selected();
      tiers.forEach(function (t) {
        var q = parseInt(t.dataset.qty, 10) || 1;
        var off = parseInt(t.dataset.off, 10) || 0;
        var base = v.compare > v.price ? v.compare : v.price;
        var total = v.price * q - off;
        var was = base * q;
        var n = t.querySelector('[data-lf-tier-now]');
        var w = t.querySelector('[data-lf-tier-was]');
        var s = t.querySelector('[data-lf-tier-save]');
        if (n) n.textContent = money(total, cur);
        if (w) { w.textContent = money(was, cur); w.style.display = was > total ? '' : 'none'; }
        if (s) {
          var tpl = s.dataset.tpl || '';
          s.textContent = was > total ? tpl.replace('[x]', money(was - total, cur)) : '';
        }
      });
    }

    function renderPrice() {
      var v = selected();
      if (nowEl) nowEl.textContent = money(v.price, cur);
      if (wasEl) { wasEl.textContent = money(v.compare, cur); wasEl.style.display = v.compare > v.price ? '' : 'none'; }
      if (saveEl) {
        if (v.compare > v.price) {
          var pct = Math.round((v.compare - v.price) * 100 / v.compare);
          saveEl.querySelector('span').textContent = (saveEl.dataset.word || '') + ' ' + pct + '%';
          saveEl.style.display = '';
        } else { saveEl.style.display = 'none'; }
      }
      if (sticky) {
        var sp = sticky.querySelector('[data-lf-sticky-price]');
        if (sp) sp.innerHTML = '<b>' + money(v.price, cur) + '</b>' + (v.compare > v.price ? '<s>' + money(v.compare, cur) + '</s>' : '');
      }
      renderTiers();
    }

    function syncUnitsToColor() {
      var v = selected();
      root.querySelectorAll('[data-lf-unit]').forEach(function (sel) {
        if (!sel.dataset.touched) sel.value = String(v.id);
      });
    }

    root.querySelectorAll('[data-lf-opt] input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var v = selected();
        if (optName) optName.textContent = inp.value;
        renderPrice();
        syncUnitsToColor();
        if (gallery && gallery.goTo && v.img > 0) gallery.goTo(v.img - 1);
      });
    });
    root.querySelectorAll('[data-lf-unit]').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.dataset.touched = '1'; });
    });

    function activeTier() {
      var on = null;
      tiers.forEach(function (t) { if (t.classList.contains('is-on')) on = t; });
      return on;
    }
    tiers.forEach(function (t) {
      var radio = t.querySelector('input[type=radio]');
      function pick() {
        tiers.forEach(function (o) { o.classList.remove('is-on'); var r = o.querySelector('input[type=radio]'); if (r) r.checked = false; });
        t.classList.add('is-on');
        if (radio) radio.checked = true;
      }
      t.addEventListener('click', function (e) { if (e.target.closest('select')) return; pick(); });
      if (radio) radio.addEventListener('change', pick);
    });

    function buildItems() {
      var t = activeTier();
      var v = selected();
      if (!t) return [{ id: v.id, quantity: 1 }];
      var q = parseInt(t.dataset.qty, 10) || 1;
      var sels = t.querySelectorAll('[data-lf-unit]');
      if (!sels.length || q === 1) return [{ id: v.id, quantity: q }];
      var map = {};
      sels.forEach(function (s) { map[s.value] = (map[s.value] || 0) + 1; });
      return Object.keys(map).map(function (id) { return { id: parseInt(id, 10), quantity: map[id] }; });
    }

    function submit(dest, btn) {
      if (errEl) errEl.style.display = 'none';
      var label = btn.innerHTML;
      btn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: buildItems() })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Error'); });
        window.location.href = dest;
      }).catch(function (err) {
        btn.disabled = false;
        btn.innerHTML = label;
        if (errEl) { errEl.textContent = err.message; errEl.style.display = 'block'; }
      });
    }
    var add = root.querySelector('[data-lf-add]');
    var buy = root.querySelector('[data-lf-buynow]');
    if (add) add.addEventListener('click', function (e) { e.preventDefault(); submit(add.dataset.dest || '/cart', add); });
    if (buy) buy.addEventListener('click', function (e) { e.preventDefault(); submit('/checkout', buy); });

    if (sticky) {
      var target = root.querySelector('[data-lf-actions]');
      var stickyBtn = sticky.querySelector('[data-lf-sticky-btn]');
      if (stickyBtn && target) stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      if ('IntersectionObserver' in window && target) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
          });
        }).observe(target);
      }
    }

    renderPrice();
    syncUnitsToColor();
  }

  function initAll(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-lf-scroller]').forEach(initScroller);
    s.querySelectorAll('[data-lf-timeline]').forEach(initTimeline);
    s.querySelectorAll('[data-lf-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
